import { render, staticRenderFns } from "./client_page.vue?vue&type=template&id=69dcc44a&scoped=true"
import script from "./client_page.vue?vue&type=script&lang=js"
export * from "./client_page.vue?vue&type=script&lang=js"
import style0 from "./client_page.vue?vue&type=style&index=0&id=69dcc44a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dcc44a",
  null
  
)

export default component.exports